// import io from "socket.io-client";
// import { BASE_URL } from "../utils/contants";
// class SocketService {
//   constructor() {
//     // @ts-ignore
//     this.socket = null;
//     // @ts-ignore
//     this.isConnected = false;
//   }
//   connect(serverUrl = BASE_URL) {
//     return new Promise((resolve, reject) => {
//     // @ts-ignore
//       this.socket = io(serverUrl, {
//         path: "/socket",
//         transports: ["websocket"],
//         reconnection: true,
//         reconnectionDelay: 1000,
//         reconnectionAttempts: 5,
//       });
//     // @ts-ignore
//       this.socket.on("connect", () => {
//     // @ts-ignore
//         console.log("Socket connected:", this.socket.id);
//     // @ts-ignore
//         this.isConnected = true;
//     // @ts-ignore
//         resolve();
//       });
//     // @ts-ignore
//       this.socket.on("connect_error", (error:any) => {
//         console.error("Connection error:", error);
//     // @ts-ignore
//         this.isConnected = false;
//         reject(error);
//       });
//     // @ts-ignore
//       this.socket.on("disconnect", () => {
//         console.log("Socket disconnected");
//     // @ts-ignore
//         this.isConnected = false;
//       });
//     });
//   }
//   disconnect() {
//     // @ts-ignore
//     if (this.socket) {
//     // @ts-ignore
//       this.socket.disconnect();
//     // @ts-ignore
//       this.socket = null;
//     // @ts-ignore
//       this.isConnected = false;
//     }
//   }
//   // Room methods
//   createRoom(playerName:any, numPlayers:any) {
//     return new Promise((resolve, reject) => {
//     // @ts-ignore
//       this.socket.emit("createRoom", { playerName, numPlayers }, (response) => {
//         if (response.success) {
//           resolve(response);
//         } else {
//           reject(response.message);
//         }
//       });
//     });
//   }
//   joinRoom(roomId:any, playerName:any) {
//     return new Promise((resolve, reject) => {
//     // @ts-ignore
//       this.socket.emit("joinRoom", { roomId, playerName }, (response) => {
//         if (response.success) {
//           resolve(response);
//         } else {
//           reject(response.message);
//         }
//       });
//     });
//   }
//   toggleReady(roomId:any) {
//     return new Promise((resolve) => {
//     // @ts-ignore
//       this.socket.emit("toggleReady", { roomId }, resolve);
//     });
//   }
//   startGame(roomId:any) {
//     return new Promise((resolve, reject) => {
//     // @ts-ignore
//       this.socket.emit("startGame", { roomId }, (response) => {
//         if (response.success) {
//           resolve(response);
//         } else {
//           reject(response.message);
//         }
//       });
//     });
//   }
//   leaveRoom(roomId:any) {
//     // @ts-ignore
//     this.socket.emit("leaveRoom", { roomId });
//   }
//   // Turn advance
//   advanceTurn(roomId:any) {
//     // @ts-ignore
//     this.socket.emit("advanceTurn", { roomId });
//   }
//   // Game sync methods
//   syncGameState(roomId:any, gameState:any) {
//     // @ts-ignore
//     this.socket.emit("syncGameState", { roomId, gameState });
//   }
//   emitDiceRoll(roomId:any, diceValue:any, playerId:any) {
//     // @ts-ignore
//     this.socket.emit("diceRolled", { roomId, diceValue, playerId });
//   }
//   emitTokenMove(roomId:any, moveData:any) {
//     // @ts-ignore
//     this.socket.emit("tokenMoved", { roomId, moveData });
//   }
//   // Chat methods
//     // @ts-ignore
//   sendMessage(roomId, message, senderName) {
//     // @ts-ignore
//     this.socket.emit("sendMessage", { roomId, message, senderName });
//   }
//   // Voice methods
//     // @ts-ignore
//   sendWebRTCOffer(roomId, offer, targetId) {
//     // @ts-ignore
//     this.socket.emit("webrtc-offer", { roomId, offer, targetId });
//   }
//     // @ts-ignore
//   sendWebRTCAnswer(roomId, answer, targetId) {
//     // @ts-ignore
//     this.socket.emit("webrtc-answer", { roomId, answer, targetId });
//   }
//     // @ts-ignore
//   sendICECandidate(roomId, candidate, targetId) {
//     // @ts-ignore
//     this.socket.emit("webrtc-ice-candidate", { roomId, candidate, targetId });
//   }
//     // @ts-ignore
//   toggleMute(roomId, isMuted) {
//     // @ts-ignore
//     this.socket.emit("toggleMute", { roomId, isMuted });
//   }
//   // Event listeners
//     // @ts-ignore
//   onPlayerJoined(callback) {
//     // @ts-ignore
//     this.socket.on("playerJoined", callback);
//   }
//     // @ts-ignore
//   onPlayerLeft(callback) {
//     // @ts-ignore
//     this.socket.on("playerLeft", callback);
//   }
//     // @ts-ignore
//   onRoomUpdated(callback) {
//     // @ts-ignore
//     this.socket.on("roomUpdated", callback);
//   }
//     // @ts-ignore
//   onGameStarted(callback) {
//     // @ts-ignore
//     this.socket.on("gameStarted", callback);
//   }
//     // @ts-ignore
//   onGameStateUpdated(callback) {
//     // @ts-ignore
//     this.socket.on("gameStateUpdated", callback);
//   }
//     // @ts-ignore
//   onOpponentDiceRolled(callback) {
//     // @ts-ignore
//     this.socket.on("opponentDiceRolled", callback);
//   }
//     // @ts-ignore
//   onOpponentTokenMoved(callback) {
//     // @ts-ignore
//     this.socket.on("opponentTokenMoved", callback);
//   }
//     // @ts-ignore
//   onNewMessage(callback) {
//     // @ts-ignore
//     this.socket.on("newMessage", callback);
//   }
//     // @ts-ignore
//   onAdvanceTurn(callback) {
//     // @ts-ignore
//     this.socket.on("advanceTurn", callback);
//   }
//     // @ts-ignore
//   onGameOver(callback) {
//     // @ts-ignore
//     this.socket.on("gameOver", callback);
//   }
//     // @ts-ignore
//   onWebRTCOffer(callback) {
//     // @ts-ignore
//     this.socket.on("webrtc-offer", callback);
//   }
//     // @ts-ignore
//   onWebRTCAnswer(callback) {
//     // @ts-ignore
//     this.socket.on("webrtc-answer", callback);
//   }
//     // @ts-ignore
//   onICECandidate(callback) {
//     // @ts-ignore
//     this.socket.on("webrtc-ice-candidate", callback);
//   }
//     // @ts-ignore
//   onPlayerMuteChanged(callback) {
//     // @ts-ignore
//     this.socket.on("playerMuteChanged", callback);
//   }
//   // Remove listeners
//   removeAllListeners() {
//     // @ts-ignore
//     if (this.socket) {
//     // @ts-ignore
//       this.socket.removeAllListeners();
//     }
//   }
//     // @ts-ignore
//   removeListener(event) {
//     // @ts-ignore
//     if (this.socket) {
//     // @ts-ignore
//       this.socket.off(event);
//     }
//   }
// }
// export default new SocketService();


// with profile photo
// @ts-nocheck
import io from "socket.io-client";
import { BASE_URL } from "../utils/contants";
class SocketService {
  constructor() {
    // @ts-ignore
    this.socket = null;
    // @ts-ignore
    this.isConnected = false;
    // @ts-ignore
    this.currentRoomId = null;
    // @ts-ignore
    this.currentPlayerName = null;
    // @ts-ignore
    this.currentProfilePhoto = null;
    // @ts-ignore
    this.currentUserId = null;
  }
  connect(serverUrl = BASE_URL) {
    return new Promise((resolve, reject) => {
    // @ts-ignore
      this.socket = io(serverUrl, {
        path: "/socket",
        transports: ["websocket"],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: Infinity, // Changed to infinite attempts
      });
    // @ts-ignore
      this.socket.on("connect", () => {
    // @ts-ignore
        console.log("Socket connected:", this.socket.id);
    // @ts-ignore
        this.isConnected = true;
    // @ts-ignore
        resolve();
      });
    // @ts-ignore
      this.socket.on("reconnect", (attempts) => {
        console.log("Reconnected after", attempts, "attempts");
        if (this.currentRoomId && this.currentPlayerName && this.currentProfilePhoto && this.currentUserId) {
          this.socket.emit("joinRoom", { 
            roomId: this.currentRoomId, 
            playerName: this.currentPlayerName, 
            profilePhoto: this.currentProfilePhoto,
            userId: this.currentUserId 
          }, (response: any) => {
            if (response.success) {
              console.log("Rejoined room successfully");
            } else {
              console.error("Failed to rejoin room:", response.message);
            }
          });
        }
      });
    // @ts-ignore
      this.socket.on("connect_error", (error:any) => {
        console.error("Connection error:", error);
    // @ts-ignore
        this.isConnected = false;
        reject(error);
      });
    // @ts-ignore
      this.socket.on("disconnect", () => {
        console.log("Socket disconnected");
    // @ts-ignore
        this.isConnected = false;
      });
    });
  }
  disconnect() {
    // @ts-ignore
    if (this.socket) {
    // @ts-ignore
      this.socket.disconnect();
    // @ts-ignore
      this.socket = null;
    // @ts-ignore
      this.isConnected = false;
      this.currentRoomId = null;
      this.currentPlayerName = null;
      this.currentProfilePhoto = null;
      this.currentUserId = null;
    }
  }
  // Room methods
  createRoom(playerName:any, profilePhoto:any, numPlayers:any, userId: any) {
    return new Promise((resolve, reject) => {
    // @ts-ignore
      this.socket.emit("createRoom", { playerName, profilePhoto, numPlayers, userId }, (response) => {
        if (response.success) {
          this.currentRoomId = response.roomId;
          this.currentPlayerName = playerName;
          this.currentProfilePhoto = profilePhoto;
          this.currentUserId = userId;
          resolve(response);
        } else {
          reject(response.message);
        }
      });
    });
  }
  joinRoom(roomId:any, playerName:any, profilePhoto:any, userId: any) {
    return new Promise((resolve, reject) => {
    // @ts-ignore
      this.socket.emit("joinRoom", { roomId, playerName, profilePhoto, userId }, (response) => {
        if (response.success) {
          this.currentRoomId = roomId;
          this.currentPlayerName = playerName;
          this.currentProfilePhoto = profilePhoto;
          this.currentUserId = userId;
          resolve(response);
        } else {
          reject(response.message);
        }
      });
    });
  }
  toggleReady(roomId:any) {
    return new Promise((resolve) => {
    // @ts-ignore
      this.socket.emit("toggleReady", { roomId }, resolve);
    });
  }
  startGame(roomId:any) {
    return new Promise((resolve, reject) => {
    // @ts-ignore
      this.socket.emit("startGame", { roomId }, (response) => {
        if (response.success) {
          resolve(response);
        } else {
          reject(response.message);
        }
      });
    });
  }
  leaveRoom(roomId:any) {
    if (this.currentRoomId === roomId) {
      this.currentRoomId = null;
      this.currentPlayerName = null;
      this.currentProfilePhoto = null;
      this.currentUserId = null;
    }
    // @ts-ignore
    this.socket.emit("leaveRoom", { roomId });
  }
  // Turn advance
  advanceTurn(roomId:any) {
    // @ts-ignore
    this.socket.emit("advanceTurn", { roomId });
  }
  // Game sync methods
  syncGameState(roomId:any, gameState:any) {
    // @ts-ignore
    this.socket.emit("syncGameState", { roomId, gameState });
  }
  emitDiceRoll(roomId:any, diceValue:any, playerId:any) {
    // @ts-ignore
    this.socket.emit("diceRolled", { roomId, diceValue, playerId });
  }
  emitTokenMove(roomId:any, moveData:any) {
    // @ts-ignore
    this.socket.emit("tokenMoved", { roomId, moveData });
  }
  // Chat methods
    // @ts-ignore
  sendMessage(roomId, message, senderName) {
    // @ts-ignore
    this.socket.emit("sendMessage", { roomId, message, senderName });
  }
  // Voice methods
    // @ts-ignore
  sendWebRTCOffer(roomId, offer, targetId) {
    // @ts-ignore
    this.socket.emit("webrtc-offer", { roomId, offer, targetId });
  }
    // @ts-ignore
  sendWebRTCAnswer(roomId, answer, targetId) {
    // @ts-ignore
    this.socket.emit("webrtc-answer", { roomId, answer, targetId });
  }
    // @ts-ignore
  sendICECandidate(roomId, candidate, targetId) {
    // @ts-ignore
    this.socket.emit("webrtc-ice-candidate", { roomId, candidate, targetId });
  }
    // @ts-ignore
  toggleMute(roomId, isMuted) {
    // @ts-ignore
    this.socket.emit("toggleMute", { roomId, isMuted });
  }
  // Event listeners
    // @ts-ignore
  onPlayerJoined(callback) {
    // @ts-ignore
    this.socket.on("playerJoined", callback);
  }
    // @ts-ignore
  onPlayerLeft(callback) {
    // @ts-ignore
    this.socket.on("playerLeft", callback);
  }
    // @ts-ignore
  onRoomUpdated(callback) {
    // @ts-ignore
    this.socket.on("roomUpdated", callback);
  }
    // @ts-ignore
  onGameStarted(callback) {
    // @ts-ignore
    this.socket.on("gameStarted", callback);
  }
    // @ts-ignore
  onGameStateUpdated(callback) {
    // @ts-ignore
    this.socket.on("gameStateUpdated", callback);
  }
    // @ts-ignore
  onOpponentDiceRolled(callback) {
    // @ts-ignore
    this.socket.on("opponentDiceRolled", callback);
  }
    // @ts-ignore
  onOpponentTokenMoved(callback) {
    // @ts-ignore
    this.socket.on("opponentTokenMoved", callback);
  }
    // @ts-ignore
  onNewMessage(callback) {
    // @ts-ignore
    this.socket.on("newMessage", callback);
  }
    // @ts-ignore
  onAdvanceTurn(callback) {
    // @ts-ignore
    this.socket.on("advanceTurn", callback);
  }
    // @ts-ignore
  onGameOver(callback) {
    // @ts-ignore
    this.socket.on("gameOver", callback);
  }
    // @ts-ignore
  onWebRTCOffer(callback) {
    // @ts-ignore
    this.socket.on("webrtc-offer", callback);
  }
    // @ts-ignore
  onWebRTCAnswer(callback) {
    // @ts-ignore
    this.socket.on("webrtc-answer", callback);
  }
    // @ts-ignore
  onICECandidate(callback) {
    // @ts-ignore
    this.socket.on("webrtc-ice-candidate", callback);
  }
    // @ts-ignore
  onPlayerMuteChanged(callback) {
    // @ts-ignore
    this.socket.on("playerMuteChanged", callback);
  }
  // Remove listeners
  removeAllListeners() {
    // @ts-ignore
    if (this.socket) {
    // @ts-ignore
      this.socket.removeAllListeners();
    }
  }
    // @ts-ignore
  removeListener(event) {
    // @ts-ignore
    if (this.socket) {
    // @ts-ignore
      this.socket.off(event);
    }
  }
}
export default new SocketService();